export enum DeleteSpecial {
  REMOVE_ITEMS = 'remove items',
  KEEP_ITEMS = 'keep items',
  PROMPT = 'prompt',
}
